// @flow
import React, {useRef} from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import ReactTooltip from "../../../src/react-tooltip/dist/index";

const toolTipClass = 'text-md   leading-none mt-3 smalltext'
type Props = {
    click: Function
};
const menuScale = (scale) => {
    var z = Math.round((1 / scale) * 100) / 100;
    return 'scale(' + z + ',' + z + ')';
};
export default function DraggableRemoveHandler({click, RemoveIconScale}: Props) {
    const inputRef = useRef<HTMLInputElement>(null);
    const [isTooltipOpen, setisTooltipOpen] = React.useState(false);
    return (
        <div className="removeElement" id="removeElement" rmthumb="1"
             style={{fontSize: "12px", transform: menuScale(RemoveIconScale), transformOrigin: '0 0'}}
             ref={inputRef}
        >
            <button
                onClick={(e) => {
                    setTimeout(() => {
                        ReactTooltip.hide();
                    }, 2000);
                    click(e);
                }}
                className="inline-flex pb-3 rounded bg-grey-light align-top" type="button"
                data-tip data-for="removeBtn"
            >
                <FontAwesomeIcon color="#333" icon="trash"
                                 onMouseEnter={(e) => {
                                     var tlp = document.getElementById("tooltipremove");
                                     var co = inputRef.current.getBoundingClientRect();
                                     {
                                         tlp.style.left = (co.left + (24)) + "px"
                                         tlp.style.top = (co.top - (1)) + "px"
                                         tlp.style.opacity = 1
                                         console.log(e.pageY, co.top)
                                     }
                                 }
                                 }
                                 onMouseLeave={(e) => {
                                     var tlp = document.getElementById("tooltipremove");
                                     tlp.style.opacity = 0
                                 }
                                 }
                />
            </button>
        </div>
    );
}
